import React, {useEffect} from "react";
import ReactGA from "react-ga";
import {Grid} from "@mui/material";
import {Box} from "@mui/system";
import {GOOGLE_ANALYTICS_TRACKING_ID} from "_constants";
import {history} from "_helpers";
import CurvedFooter from "../Utils/CurvedFooter";
import importedStyles from "../Utils/styles";
import RemarkableWordmark from "../Utils/RemarkableWordmark";
import GetStartedDescription from "../Utils/GetStartedDescription";
import StepIndicator from "../Utils/StepIndicator";
import SignupForm from "../Utils/SignupForm";

export default function OrganizationSignup() {
    if (JSON.parse(localStorage.getItem('user'))) history.push('/dashboard');

    useEffect(() => {
        ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
        ReactGA.pageview(window.location.pathname);

        document.body.style.backgroundColor = '#edede4';
        return () => {
            document.body.style.backgroundColor = '';
        };
    }, []);

    return(
        <>
            <Box sx={styles.root}>
                <Grid container sx={styles.container}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box sx={{mt: '35px'}}>
                            <RemarkableWordmark/>
                        </Box>

                        <Box sx={styles.descriptionContainer}>
                            <Box sx={{mb: '40px'}}>
                                <StepIndicator current={1} total={2} />
                            </Box>
                            <GetStartedDescription/>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}
                          px={{xs: '20px', sm: '20px', md: '35px', lg: '50px'}}
                          sx={{height: "fit-content"}}>
                        <SignupForm/>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={styles.footerContainer}>
                <CurvedFooter />
            </Box>
        </>
    )
}

const styles = {
    root: {
        background: "#edede4",
        minHeight: 'calc(100vh - 220px)',
    },
    container: {
        ...importedStyles.container,
        width: '100%',
    },
    footerContainer: {
        width: '100%',
        height: {xs: '270px', md: '220px'},
    },
    descriptionContainer: {
        height: 'auto',
        marginTop: { xs: '50px', sm: '50px', md: '100px', lg: '100px' }
    }
}